export default {
  
  featuredItem: "FEATURED ITEMS",
  yourcart:"My Cart",
  cartisempty: "Your cart is empty now. Add items to place an order.",
  ItemTotal:"Item Total",
  GST:"GST",
  TOPAY:"TO PAY",
  Message: "Terms and Conditions Apply",
  termsConditions: [
    "Dish photos may differ from actual presentation.",
    "Items are subjected to availability.",
    "Delivery time for every order is 30-45 min. Please co-operate."
  ],

  CustomerDetails:"Customer Details",
  PlaceOrder:"Place Order",
  filterditem:"Sorry, We couldn't find anything please search from all category"
};
